// components/ConfirmModal.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  title = 'Tasdiqlash', 
  message = 'Siz bunga ishonchingiz komilmi?',
  confirmText = "Ha, o'chirish",
  cancelText = 'Bekor qilish'
}) => {
  const modalStyle = {
    zIndex: 9999, // Very high z-index to ensure it's on top
  };

  const backdropStyle = {
    zIndex: 9000, // Slightly lower than modal but still very high
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      style={modalStyle}
      backdropStyle={backdropStyle}
    >
      <Modal.Header closeButton style={{ backgroundColor: 'whitesmoke' }}>
        <Modal.Title className="fw-bold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body >
        {typeof message === 'string' ? <p className="mb-0">{message}</p> : message}
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          {cancelText}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
    );
};

export default ConfirmModal;
